export default {"src":"/_next/static/media/404_marcos.31320965.svg","height":241,"width":305};